import React, { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
	faChevronRight,
	faChevronDown,
} from '@fortawesome/free-solid-svg-icons';

interface SidebarMenuProps {
	label: string;
	icon: IconProp;
	basePath: string;
	isOpen: boolean;
	onToggle: () => void;
	children: React.ReactNode;
}

const SidebarMenu: React.FC<SidebarMenuProps> = ({
	label,
	icon,
	isOpen,
	onToggle,
	children,
}) => {
	const contentRef = useRef<HTMLDivElement>(null);
	const [height, setHeight] = useState('0px');

	useEffect(() => {
		if (contentRef.current) {
			setHeight(isOpen ? `${contentRef.current.scrollHeight}px` : '0px');
		}
	}, [isOpen, children]);

	const handleClick = () => {
		onToggle();
	};

	return (
		<div className="flex flex-col">
			<div
				onClick={handleClick}
				className={`flex items-center justify-between p-2 rounded cursor-pointer transition-colors text-gray-300 hover:bg-gray-600`}
			>
				<div className="flex items-center gap-2">
					<FontAwesomeIcon icon={icon} className="w-4 h-4" />
					{label}
				</div>
				<FontAwesomeIcon
					icon={isOpen ? faChevronDown : faChevronRight}
					className="w-3 h-3"
				/>
			</div>

			<div
				ref={contentRef}
				style={{
					maxHeight: height,
					overflow: 'hidden',
					transition: 'max-height 0.3s ease',
				}}
				className="ml-6 mt-1 flex flex-col"
			>
				{children}
			</div>
		</div>
	);
};

export default SidebarMenu;
